module.exports = __webpack_public_path__ + "img/normal.a04d41fa.png";